module.exports = __webpack_public_path__ + "img/lavrov.99f81dc9.png";